import React from 'react';
import { Helmet } from 'react-helmet';
import { Box, Container } from '@mui/material';
import SharedvmLabList from '../../components/labstructure/Sharedvmlabs/LabList';

const Labs = () => {

  return (
  <React.Fragment>
    <Helmet>
      <title>LabAsService</title>
    </Helmet>
    <Box
      sx={{
        backgroundColor: 'background.default',
        minHeight: '100%',
        py: 3
      }}
    >
      <Container maxWidth={false}>
      
       <SharedvmLabList />
       
      </Container>
    </Box>
  </React.Fragment>
 );
}

export default Labs;